export const users = [
    {
        email: "admin@yopmail.com",
        password: "admin123",
        type: "admin"
    },
    {
        email: "abonne@yopmail.com",
        password: "user123",
        type: "abonnes"
    },
    {
        email: "institution@yopmail.com",
        password: "user123",
        type: "institution"
    },
    {
        email: "gestion@yopmail.com",
        password: "user123",
        role: "gestion"
    }
];